import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as requirements from '../../requirements'

export const RESOURCE = {
  payload: {
    description:
      'One Jira task, keyed by its Jira key. Jira writes it; GitHub only sets the technical requirement fields.',
    dimension: requirements.RESOURCE.payload,
    level: 0,
    name: 'Requirement',
    partialId: PartialId.Standard.create('requirement'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
